const CAMPOS_VENDA_GUARDADA = [
  "carrinho", "clienteSelecionado", "modoCliente", "clienteManualNome",
  "clienteManualDocumento", "vendedorSelecionado", "listaPrecoSelecionada",
  "listaPrecoDeCliente", "idListaPrecoCliente", "listaPrecoMap",
  "listaPagamentos", "formaPagamentoSelecionada", "valorPagamentoAtual",
  "pagamentoRapidoAtivo", "parcelasVencimento", "diasParcelas",
  "descontoVendaReais", "descontoVendaPct", "acrescimoVendaReais",
  "acrescimoVendaPct", "observacaoVenda",
];

function criarSnapshotVenda(origem) {
  const dados = { versao: 1 };
  for (const campo of CAMPOS_VENDA_GUARDADA) dados[campo] = origem[campo];
  return JSON.parse(JSON.stringify(dados));
}

function validarSnapshotVenda(dados) {
  if (dados?.versao !== 1 || !Array.isArray(dados.carrinho) || !dados.carrinho.length) {
    throw new Error("A venda guardada deve conter pelo menos um item válido.");
  }
  for (const item of dados.carrinho) {
    if (!item?.id_produto || !Number.isFinite(Number(item.quantidade)) || Number(item.quantidade) <= 0 ||
        !Number.isFinite(Number(item.valor_unitario)) || Number(item.valor_unitario) < 0 ||
        !Number.isFinite(Number(item.total)) || Number(item.total) < 0) {
      throw new Error("A venda contém um item com quantidade ou valor inválido.");
    }
  }
  for (const campo of ["descontoVendaReais", "descontoVendaPct", "acrescimoVendaReais", "acrescimoVendaPct"]) {
    if (dados[campo] != null && (!Number.isFinite(Number(dados[campo])) || Number(dados[campo]) < 0)) {
      throw new Error("A venda contém um desconto ou acréscimo inválido.");
    }
  }
  return criarSnapshotVenda(dados);
}

function quantidadeEstoqueItem(item, quantidade = item.quantidade) {
  const fator = Number(item.embalagem?.fator_conversao ?? item.produto_original?.embalagem_selecionada?.fator_conversao) || 1;
  return Number((Number(quantidade) * fator).toFixed(8));
}

module.exports = { CAMPOS_VENDA_GUARDADA, criarSnapshotVenda, validarSnapshotVenda, quantidadeEstoqueItem };
